import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../../shared/providers/routing.service';
import {
  City,
  Country,
  Company,
  NewPointCedi,
} from 'src/app/components/massive/pages/create/components/parametrizacion/parametrizacion.interface';
import { MessageService } from 'primeng/api';
import { MuLayoutService } from 'src/app/components/shared/sharedProtos/layout/mu-layout.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-list-cedi',
  templateUrl: './list-cedi.component.html',
  styleUrls: ['./list-cedi.component.sass'],
  providers: [MessageService],
})
export class ListCediComponent implements OnInit {
  public hostUrlBack: string;
  public cities: City[];
  public filteredCities: City[] = [];
  public selectedCountry: Country;
  public companies: Company[];
  public selectedCompany: Company;
  public filteredCompanies: Company[] = [];
  public clientPoints: NewPointCedi[] = [];
  public editCedi: NewPointCedi[];
  public editPointCEdi: NewPointCedi;
  public labelButtonCedi = 'EDITAR CEDI';
  public labelCreateCedi = 'CREAR CEDI';
  public first = 0;

  public showEditCedi = false;
  public showCreateCedi = false;
  public showDeleteCedi = false;

  constructor(private routingSvc: RoutingService, private messageService: MessageService, private layoutService: MuLayoutService) {
    this.layoutService.currentCountryValue.subscribe(countryVal => {
      const result = environment.countries.filter(item => item.geoName === countryVal);
      this.selectedCountry = result[0];
    });
  }

  ngOnInit(): void {
    this.routingSvc
      ?.handleCompanies()
      ?.then(res => (this.companies = res))
      ?.catch(e => {
        throw e;
      });
    this.routingSvc
      ?.handleCities()
      ?.then(res => (this.cities = res))
      ?.catch(e => {
        throw e;
      });
    this.hostUrlBack = this.routingSvc.hostUrlBack;
  }

  filterCompanies($event) {
    this.filteredCompanies = [];
    this.companies.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCompanies.push(city);
      }
    });
  }

  filterCities($event) {
    this.filteredCities = [];
    this.cities.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCities.push(city);
      }
    });
  }

  updateClientPoints($event): void {
    this.routingSvc
      .handleCediByCompany($event)
      .then(res => {
        this.clientPoints = res;
      })
      .catch(e => {
        throw e;
      });
  }

  updateCediPoint(idCedi: any): void {
    this.showEditCedi = !this.showEditCedi;
    this.editPointCEdi = idCedi;
  }

  deletePointAddress(idCedi: number): void {
    this.showDeleteCedi = true;
    this.editCedi = this.clientPoints.filter(res => res.id === idCedi);
  }

  validateDeleteAddress(confirm: boolean): void {
    if (confirm) {
      this.routingSvc.deleteCeditableData(this.editCedi[0].id).then(res => {
        if (res) {
          this.updateClientPoints(this.selectedCompany);
          this.showDeleteCedi = false;
          this.messageService.add({ severity: 'success', summary: 'CEDI', detail: 'Fue eliminado con éxito!' });
        }
      });
    } else {
      this.showDeleteCedi = false;
    }
  }

  handleEditCedi(updatedPoint): void {
    this.showEditCedi = !this.showEditCedi;
    for (let index = 0; index < this.clientPoints.length; index++) {
      if (updatedPoint.newCediPoint.id === this.clientPoints[index].id) {
        this.clientPoints[index] = {
          address: updatedPoint.newCediPoint.coordinates.address,
          city: updatedPoint.newCediPoint.city.geoName,
          id: updatedPoint.newCediPoint.id,
          idCity: updatedPoint.newCediPoint.city.id,
          istDistributionCenter: updatedPoint.typeCedi === 'cedi',
          lat: updatedPoint.newCediPoint.coordinates.lat,
          lng: updatedPoint.newCediPoint.coordinates.lng,
          name: updatedPoint.newCediPoint.name,
        };
        return;
      }
    }
  }

  handleNewPoint(): void {
    this.showCreateCedi = !this.showCreateCedi;
    this.updateClientPoints(this.selectedCompany);
  }

  showSuccess(): void {
    this.messageService.add({ severity: 'success', summary: 'CEDI', detail: 'Fue editado con éxito!' });
  }
}
